module.exports = __webpack_public_path__ + "static/media/homepage_contact_bg.2e152ce6.jpg";